if (!customElements.get("m-icon-box")) {
  class MIconbox extends HTMLElement {
    constructor() {
      super();

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.enableAutoCarousel = this.dataset.enableAutoCarousel === "true";
      this.autoCarouselInterval = parseInt(this.dataset.autoCarouselInterval, 10) || 5;
      this.reducedMotionQuery =
        typeof window.matchMedia === "function" ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
      this.handleReducedMotionChange = () => this.syncAutoCarousel(this.slider);
      this.slideContainer = this.querySelector(".swiper-container");
    }

    connectedCallback() {
      this.lastActive = null;
      if (this.enableSlider) {
        this.reducedMotionQuery?.addEventListener("change", this.handleReducedMotionChange);
        this.initSlider();
      }
    }

    disconnectedCallback() {
      this.reducedMotionQuery?.removeEventListener("change", this.handleReducedMotionChange);
    }

    initSlider() {
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = this.querySelector(".swiper-wrapper").childElementCount;
      let __this = this;

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1,
        navigation: this.showNavigation,
        loop: true,
        watchOverflow: true,
        autoplay: this.enableAutoCarousel
          ? {
              delay: this.autoCarouselInterval * 1000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: {
          480: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: parseInt(this.items) - 1,
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        on: {
          init: function () {
            this.slideToLoop(this.lastActive);
            __this.syncAutoCarousel(this);
            setTimeout(() => {
              // Calculate controls position
              const firstItem = __this.querySelector(".m-image") || __this.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                prevButton?.classList.remove("m:hidden");
                nextButton?.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
            __this.syncAutoCarousel(swiper);
          },
          resize: (swiper) => this.syncAutoCarousel(swiper),
          lock: (swiper) => this.syncAutoCarousel(swiper),
          unlock: (swiper) => this.syncAutoCarousel(swiper),
        },
      });

      if (this.slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }
      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    syncAutoCarousel(swiper) {
      if (!swiper?.autoplay) return;

      const prefersReducedMotion = this.reducedMotionQuery?.matches === true;
      const shouldRun = this.enableAutoCarousel && !prefersReducedMotion && swiper.isLocked === false;

      if (shouldRun) {
        swiper.autoplay.start();
      } else {
        swiper.autoplay.stop();
      }
    }

    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-icon-box", MIconbox);
}
